import React from 'react'
import styled from 'styled-components'

// Elements
import ParseContent from 'components/shared/ParseContent'
import Plaatjie from '@ubo/plaatjie'

// Interface
import { TextProps } from 'components/flex/Text/TextShell'

const Title = styled.h2`
  color: ${({ theme }) => theme.color.primary};
  font-family: ${({ theme }) => theme.font.family.primary};
  font-weight: ${({ theme }) => theme.font.weight.extraBold};
  margin-bottom: 1.75rem;

  @media (min-width: 992px) {
    font-size: 36px;
    line-height: 1.25;
  }

  @media (max-width: 991.98px) {
    font-size: 26px;
    line-height: 1.3;
  }
`

const ColumnContent = styled(ParseContent)`
  color: ${({ theme }) => theme.color.primary};

  & p {
    font-size: ${({ theme }) => theme.font.size.medium};
    line-height: 25px;
    margin-bottom: 1rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  & a {
    color: ${({ theme }) => theme.color.dark};
    font-weight: ${({ theme }) => theme.font.weight.bold};

    &:hover {
      color: ${({ theme }) => theme.color.secondary};
    }
  }
`

const BottomImage = styled(Plaatjie)`
  width: 100%;
  height: 100%;
  max-height: 500px;
  object-fit: cover;
`

const TextTwoColumnsImage: React.FC<TextProps> = ({ fields }) => {
  const left = fields.description || fields.columns?.[0]?.description || ''
  const right =
    fields.descriptionSecond || fields.columns?.[1]?.description || ''

  const hasText = Boolean(
    (fields.title && String(fields.title).trim()) || left || right
  )
  const hasImage = Boolean(fields.image)

  if (!hasText && !hasImage) {
    return null
  }

  return (
    <section>
      <div className="container py-lg-5">
        <div className="row justify-content-center">
          <div className="col-12">
            {fields.title ? (
              <div className="row">
                <div className="col-lg-6">
                  <Title>{fields.title}</Title>
                </div>
              </div>
            ) : null}

            {(left || right) && (
              <div className="row">
                {left ? (
                  <div className="col-lg-6 mb-4 mb-lg-0">
                    <ColumnContent content={left} />
                  </div>
                ) : null}
                {right ? (
                  <div className="col-lg-6">
                    <ColumnContent content={right} />
                  </div>
                ) : null}
              </div>
            )}

            {hasImage ? (
              <div className="row pt-5">
                <div className="col-12 pt-lg-5">
                  <BottomImage image={fields.image} alt="" />
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </section>
  )
}

export default TextTwoColumnsImage
